import { Controller } from "@hotwired/stimulus"

// Copies `textValue` to the clipboard on click, flashing a check mark as
// confirmation. Used for icon-buttons inside row-link tables — a <button> is
// already skipped by row_link_controller, so the row does not navigate.
export default class extends Controller {
  static values  = { text: String }
  static targets = ["copyIcon", "doneIcon"]

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()
    let copied = true
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch (_e) {
      copied = this.fallbackCopy(this.textValue)
    }
    if (copied) this.flashDone()
  }

  flashDone() {
    if (!this.hasCopyIconTarget || !this.hasDoneIconTarget) return
    this.copyIconTarget.classList.add("hidden")
    this.doneIconTarget.classList.remove("hidden")
    if (this.resetTimer) clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      this.doneIconTarget.classList.add("hidden")
      this.copyIconTarget.classList.remove("hidden")
    }, 1200)
  }

  // execCommand path for the rare browser/context without the async Clipboard
  // API. Returns whether the copy actually succeeded.
  fallbackCopy(text) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.setAttribute("readonly", "")
    ta.style.position = "absolute"
    ta.style.left = "-9999px"
    document.body.appendChild(ta)
    ta.select()
    let copied = false
    try { copied = document.execCommand("copy") } catch (_e) { copied = false }
    document.body.removeChild(ta)
    return copied
  }

  disconnect() {
    if (this.resetTimer) clearTimeout(this.resetTimer)
  }
}
